__turbopack_context__.v({
  "placeholder": "filter-button-module-scss-module__YRky2q__placeholder",
  "tab": "filter-button-module-scss-module__YRky2q__tab",
  "tab-active": "filter-button-module-scss-module__YRky2q__tab-active",
});
